module.exports = __webpack_public_path__ + "media/images/map-icons/mapbox-navigation-5e869ceefe82e95aba0cca8193a1e0b4.png";